import { createAsyncThunk } from "@reduxjs/toolkit";
import { getProfileFormRequest } from "../../../../http/requests/profile.http";

export const fetchGetProfileForm = createAsyncThunk("profile/getForm", async () => {
  const response = await getProfileFormRequest();
  return response.data;
});
